/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface SkillField
 */
export interface SkillField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof SkillField
     */
    value: string;
}

/**
 * Check if a given object implements the SkillField interface.
 */
export function instanceOfSkillField(value: object): value is SkillField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function SkillFieldFromJSON(json: any): SkillField {
    return SkillFieldFromJSONTyped(json, false);
}

export function SkillFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function SkillFieldToJSON(value?: SkillField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

